import { useQuery } from "@tanstack/react-query";

import { EventListRequest } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

// Single

const getEventListQuery = (params: Omit<EventListRequest, "tenantId">) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["project", params, "events"],
    queryFn: async () => await getRanaApiV1().EventsApi.eventList(params),
  });
};

export const useEventListQuery = (params: Omit<EventListRequest, "tenantId">) => {
  return useQuery(getEventListQuery(params));
};
